<template>
  <div>
    <!-- <LoaderComponent v-if="!imgLoaded" size="small" inner /> -->
    <div class="preview-img" :class="{ hidden: !imgLoaded, 'align-bottom': alignBottom }">
      <RibbonComponent
        v-if="!store.showDiscreetAvailabilityStatuses"
        ref="ribbonRef"
        :text="availability?.label"
        position="left"
        :colour="availability?.colour"
      />
      <img
        ref="imgRef"
        :class="{ transition }"
        :style="imgStyle"
        :src="imgSource"
        @error="(imgSource = ProductFallbackImage), (imgLoaded = true)"
        @load.once="imgLoaded = true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import RibbonComponent from '@/components/simple/RibbonComponent.vue'
import { ProductFallbackImage } from '@/models/Image'
import { useDefaultStore } from '@/store'
import { usePropertyStore } from '@/store/propertyStore'
import { getImageUrl } from '@/utils/productUtils'
import { computed, ref, StyleValue } from 'vue'

const props = defineProps<{
  sku: string
  availabilityCode?: number
  transition?: boolean
}>()

const store = useDefaultStore()
const propertyStore = usePropertyStore()

const maxSize = 256

const imgLoaded = ref(false)
const imgRef = ref<HTMLImageElement>()
const imgSource = ref(getImageUrl(`${props.sku}.jpg`, maxSize))

const alignBottom = computed(() => {
  const imgYPosition = imgRef.value?.getBoundingClientRect()?.y
  return imgYPosition && imgYPosition + maxSize > window.innerHeight
})

const imgStyle = computed(() => {
  if (imgLoaded.value && imgRef.value) {
    const ratio = imgRef.value.naturalWidth / imgRef.value.naturalHeight || 1
    const css: StyleValue = {}

    if (ratio > 1) {
      css.width = `${maxSize}px`
      css.height = maxSize / ratio + 'px'
    } else {
      css.width = maxSize * ratio + 'px'
      css.height = `${maxSize}px`
    }

    return css
  }
  if (!props.transition) {
    return undefined
  }

  return { width: '0', height: '0' }
})

const availability = computed(() => {
  if (props.availabilityCode !== undefined) {
    return propertyStore.productAvailabilityByCode?.[props.availabilityCode]
  }
  return undefined
})
</script>

<style lang="scss" scoped>
.preview-img {
  $vertical-adjustment: calc(100% + 4px);

  position: absolute;
  left: calc(100% + 5px);
  top: $vertical-adjustment;

  padding: 5px;
  background-color: white;
  border: 1px solid #aaa;

  &.align-bottom {
    top: unset;
    bottom: $vertical-adjustment;
  }

  img {
    max-width: 256px;
    max-height: 256px;

    &.transition {
      $transition-time: 0.05s;
      transition:
        width $transition-time,
        height $transition-time;
    }
  }
}
</style>
